import { startTransition } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import T, { useTranslation } from '@wojtekmaj/react-t';

import { toast } from '@rewardopl/react-toast';

import Button from '@rewardopl/react-ui/button';
import CheckboxField from '@rewardopl/react-ui/checkbox_field';

import { patch } from '@rewardopl/utils/network';

import {
  ButtonWrapper,
  CheckboxWrapper,
  ContentWrapper,
  Footer,
  Heading,
  ScrollContainer,
  Wrapper,
} from './index.styles';

import PrivacyPolicyLink from '../../../../../privacy_policy_link';
import TermsAndConditionsLink from '../../../../../terms_and_conditions_link';

import { currentUserState } from '../../../../../../store';

import type { User } from '@rewardopl/types';

export default function AppConsentsPage() {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useAtom(currentUserState);
  const acceptTermsErrorString = useTranslation('Failed to accept Terms and Conditions');

  const { terms_accepted: userTermsAccepted } = currentUser;

  if (userTermsAccepted) {
    return <Navigate to=".." />;
  }

  const action = '/api/users/current';

  async function onSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const form = event.currentTarget;

    if (!form || !form.reportValidity()) {
      return;
    }

    const formData = new FormData(form);

    try {
      const user = (await patch(action, {
        body: formData,
      })) as User;

      startTransition(() => {
        setCurrentUser(user);

        navigate('../');
      });
    } catch {
      toast.error(acceptTermsErrorString);
    }
  }

  return (
    <form action={action} method="PATCH" onSubmit={onSubmit}>
      <Wrapper>
        <ScrollContainer>
          <ContentWrapper>
            <Heading>
              <T>Terms and conditions</T>
            </Heading>
            <CheckboxWrapper>
              <CheckboxField
                label={
                  <>
                    <T>I have read and agree to the</T> <TermsAndConditionsLink /> <T>and</T>{' '}
                    <PrivacyPolicyLink />.
                  </>
                }
                name="terms_accepted"
                required
              />
            </CheckboxWrapper>
          </ContentWrapper>
        </ScrollContainer>
        <Footer>
          <ButtonWrapper>
            <Button className="primary" type="submit">
              <T>Continue</T>
            </Button>
          </ButtonWrapper>
        </Footer>
      </Wrapper>
    </form>
  );
}
